import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { WORDMARK, WORDMARK_VIEWBOX } from './paths'

type HighlightLogoTitleProps = Omit<ComponentProps<'svg'>, 'children' | 'dangerouslySetInnerHTML'>

/**
 * The wordmark, drawn rather than typed: its letters are the brand file's, not a font's. Shares the
 * lockup's frame height, so its baseline lands where the lockup's does beside `HighlightLogo.Icon`.
 */
export function HighlightLogoTitle({ className, ...props }: HighlightLogoTitleProps) {
  return (
    <svg
      viewBox={WORDMARK_VIEWBOX}
      aria-hidden
      fill="currentColor"
      className={twMerge('h-[var(--logo-h)] w-auto shrink-0', className)}
      // Trusted: paths exported from the Highlight 2.0 Brand file and checked in.
      dangerouslySetInnerHTML={{ __html: WORDMARK }}
      {...props}
    />
  )
}
